import { FC } from 'react';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import MnoStatusMatrix, { MnoStatus } from './MnoStatusMatrix';

interface CarrierStatusSectionProps {
  data: MnoStatus[];
}

const CarrierStatusSection: FC<CarrierStatusSectionProps> = ({ data }) => {
  return (
    <RcsSectionBlock
      icon={faShareNodes}
      title="Carrier Status"
      showDivider={false}
      editable={false}
    >
      <MnoStatusMatrix mnoStatus={data} />
    </RcsSectionBlock>
  );
};

export default CarrierStatusSection;
